import React from 'react'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import CustomerServiceLayoutDefault from '../layout/default'
import CSHeader from '../partials/header'
import StyledContent from '../../../leap/components/styled-content'
import LenisProvider from '../../../contexts/lenis'
import CmsModules from '../../../leap/modules'
import {Chakra3Theme} from '../../../leap/theme'

const CustomerServiceContentPage = () => {
    const pageConfig = useCustomerServicePageConfig()
    const {id, name, description, showTitle, content, c_isLeapContent} = pageConfig
    const {body, c_colorTheme} = content || {}

    if (c_isLeapContent) {
        return (
            <LenisProvider>
                <CustomerServiceLayoutDefault fullWidth>
                    {showTitle && <CSHeader headline={name} subline={description} />}
                    {/* v2 layout is light only, so only the modules get the page theme */}
                    <Chakra3Theme theme={c_colorTheme}>
                        <CmsModules assetId={id} />
                    </Chakra3Theme>
                </CustomerServiceLayoutDefault>
            </LenisProvider>
        )
    }

    return (
        <CustomerServiceLayoutDefault maxWidth={'100%'} px={{base: 4, lg: '6.5rem', xl: 0}}>
            {showTitle && <CSHeader headline={name} subline={description} />}
            <StyledContent
                content={body?.replace(/<\/?h3>/g, (match) => match.replace('h3', 'h2'))}
                backgroundColor="stokkeCore.white"
                w={{base: '100%', '2xl': '96rem'}}
                py={{base: 8, lg: 10}}
                px={{base: 4, lg: '5.25rem', '2xl': '16rem'}}
            />
        </CustomerServiceLayoutDefault>
    )
}

export default CustomerServiceContentPage
